export default __webpack_public_path__ + "static/media/datepicker.5e582716.svg";